import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: '#ffffff1a',
} as const

export const resources = {
  loginBg: '',
  logo: '/images/fictora/logo.webp',
  novel: '',
  facebookIcon: '/images/fictora/login/icon-facebook-logo.png',
  googleIcon: '/images/fictora/login/icon-google-logo.png',
  appleIcon: '/images/fictora/login/icon-apple-logo.png',
  emailIcon: '/images/fictora/login/icon-email.png',
  emailCodeIcon: '/images/fictora/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
